import React, { useEffect, useState } from "react";
import { ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import {
  getTeamMembers,
  getTeamMilestone,
  UpdateTask,
} from "../../../../../redux/team/action";
import { getPriority } from "../../../../../redux/categary/action";
import ReactSelect from "react-select";
import FileUpload1 from "./FileUpload1";
import { today } from "../../../../../CloudStorage/CommonFunction";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import { descriptionvalidation, titlevalidation } from "../../../../Common/commonvalidation";

const validationSchema = Yup.object().shape({
  title: titlevalidation,
  team_milestone_id: Yup.string().required("Milestone is required"),
  priority_id: Yup.string().required("Priority option is required"),
  expert_id: Yup.string().required("Expert is required"),
  due_date: Yup.date().required("Due date is required"),
  description: descriptionvalidation,
  files: Yup.array()
    .min(1, "At least one file is required")
    .required("Files are required"),
});


export default function TeamsUpdateTaskModel({
  setTaskModel,
  projectid,
  itemdata,
  setviewModel,
}) {
  const [loading, setLoading] = useState(false);
  const [work_sample, setWork_sample] = useState(null);
  const [formData, setFormData] = useState(null);
  const [priorityindex, setpriorityindex] = useState(null);
  const [assignindex, setassignindex] = useState(null);
  const [milestoneindex, setmilestoneindex] = useState(null);

  const dispatch = useDispatch();

  const allperiority = useSelector(
    ({ categary: { prioritylist } }) => prioritylist,
  );
  const allmembers = useSelector(
    ({ team: { getteammemberss } }) => getteammemberss,
  );

  const allmilestone = useSelector(
    ({ team: { getteammilestones } }) => getteammilestones,
  );

  useEffect(() => {
    if (itemdata) {
      setpriorityindex(
        Array.isArray(allperiority) &&
          allperiority
            .map((lang) => ({ value: lang.id, label: lang.title }))
            ?.find((item) => item.value == itemdata?.priority_id),
      );
      setassignindex(
        Array.isArray(allmembers) &&
          allmembers
            ?.map((lang) => ({
              value: lang.expert_id,
              label: `${lang.first_name} ${lang.last_name}`,
            }))
            ?.find((item) => item.value == itemdata?.expert_id),
      );
      setmilestoneindex(
        Array.isArray(allmilestone) &&
          allmilestone
            ?.map((lang) => ({ value: lang.id, label: `${lang.title}` }))
            ?.find((item) => item.value == itemdata?.team_milestone_id),
      );
      setWork_sample(itemdata.files);
    }
  }, [itemdata, setTaskModel]);

  const formik = useFormik({
    initialValues: {
      title: itemdata?.title || "",
      priority_id: itemdata?.priority_id || "",
      expert_id: itemdata?.expert_id || "",
      team_milestone_id: itemdata.team_milestone_id || "",
      due_date: itemdata?.due_date || "",
      description: itemdata?.description || "",
      files: itemdata?.files,
    },
    validationSchema,
    onSubmit: (values) => {
      setLoading(true);

      // const files = {
      //   ...itemdata?.files,
      //   ...formik.values.files,
      // };
      const data = {
        id: itemdata?.id,
        type: 7,
        team_project_id: projectid,
        title: values.title,
        team_milestone_id: values.team_milestone_id,
        priority_id: values.priority_id,
        expert_id: values.expert_id,
        due_date: values.due_date,
        description: values.description,
        files: formik.values.files,
      };
      dispatch(UpdateTask(data));
      setTaskModel((state) => !state);
      setviewModel(false);
      setLoading(true);
    },
  });

  useEffect(() => {
    if (formData) {
      formik.setValues(formData);
    }
  }, [formData]);

  useEffect(() => {
    dispatch(getPriority());
    dispatch(getTeamMembers());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getTeamMilestone(projectid));
  }, [dispatch, projectid]);

  useEffect(() => {
    if (work_sample) {
      formik.setFieldValue("files", work_sample);
    }
  }, [work_sample]);

console.log(itemdata, "itemdata")  
  return (
    <>
      <div className="add-task">
        <h6>Update Task</h6>
        <button
          onClick={() => setTaskModel((state) => !state)}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt=""
          />
        </button>
      </div>
      <ModalBody>
        <div>
          <div className="">
            <form onSubmit={formik.handleSubmit}>
              <div className="form-group">
                <label className="label">Task Title *</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                                    placeholder="Enter Title"

                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.title && formik.errors.title && (
                  <div style={{ color: "red" }}>{formik.errors.title}</div>
                )}
              </div>

              <div className="form-group">
                <label className="label">Description *</label>
                <textarea
                  name="description"
                  className="form-control"
                  placeholder="Describe what task is about"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.description && formik.errors.description && (
                  <div style={{ color: "red" }}>
                    {formik.errors.description}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label className="label">Assign to *</label>
                <ReactSelect
                  options={allmembers && allmembers
                    // Array.isArray(allmembers) &&
                    // allmembers.map((lang) => ({
                    //   value: lang.expert_id,
                    //   label: `${lang.first_name} ${lang.last_name}`,
                    // }))
                  }
                  getOptionLabel={option=>`${option.first_name} ${option.last_name}`}
                  getOptionValue={option=>option.expert_id}
                  placeholder={"Search for assignee"}
                  value={allmembers && allmembers.filter((expert)=>expert.expert_id ===formik.values.expert_id)}
                  onChange={(options) => {
                    setassignindex(options);
                    formik.setFieldValue("assignindex", options);
                    formik.setFieldValue("expert_id", options.expert_id);
                  }}
                />
                {formik.touched.expert_id && formik.errors.expert_id && (
                  <div style={{ color: "red" }}>{formik.errors.expert_id}</div>
                )}
              </div>

              <div className="form-group">
                <label className="label">Due Date *</label>
                <input
                  type="date"
                  name="due_date"
                  className="form-control"
                  placeholder="Enter due date"
                  value={formik.values.due_date}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  min={today}
                />
                {formik.touched.due_date && formik.errors.due_date && (
                  <div style={{ color: "red" }}>{formik.errors.due_date}</div>
                )}
              </div>

              <div className="form-group">
                <label className="label">Set Priority *</label>
                <ReactSelect
                  options={allperiority && allperiority }
                  getOptionLabel={option=>option.title}
                  getOptionValue={option=>option.id}
                  placeholder={"Select An Option"}
                  value={Array.isArray(allperiority) && allperiority.filter((priority)=>priority.id === formik.values.priority_id)}
                  onChange={(options) => {
                    setpriorityindex(options);
                    formik.setFieldValue("priority_index", options);
                    formik.setFieldValue("priority_id", options.id);
                  }}
                />
                {formik.touched.priority_id && formik.errors.priority_id && (
                  <div style={{ color: "red" }}>
                    {formik.errors.priority_id}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label className="label">Milestone *</label>
                <ReactSelect
                  options={allmilestone && allmilestone}
                  placeholder="Select Milestone"
                  getOptionLabel={option=>option.title}
                  getOptionValue={option=>option.id}
                  value={Array.isArray(allmilestone) && allmilestone.filter((mile_stone)=>mile_stone.id === formik.values.team_milestone_id)}
                  onChange={(options) => {
                    setmilestoneindex(options);
                    formik.setFieldValue("milestoneindex", options);
                    formik.setFieldValue("team_milestone_id", options.id);
                  }}
                />
                {formik.touched.team_milestone_id &&
                  formik.errors.team_milestone_id && (
                    <div style={{ color: "red" }}>
                      {formik.errors.team_milestone_id}
                    </div>
                  )}
              </div>
              {}

              <div className="form-group">
                <FileUpload1
                  setWork_sample={setWork_sample}
                  // selectedfiles={work_sample?.files}
                  worksampleFiles={work_sample}
                />
                {formik.touched.files && formik.errors.files && (
                  <div style={{ color: "red" }}>{formik.errors.files}</div>
                )}
              </div>
            </form>
          </div>
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button
          className="btn "
          onClick={() => formik.handleSubmit()}
          type="submit"
          disabled={loading}
        >
          {loading ? <LoginLoaderButton /> : "Save"}
        </button>
      </div>
    </>
  );
}
